import React from 'react';
// Helper function to generate error counts based on time range
const generateErrorCounts = (timeRange: string) => {
  // Base multiplier based on time range
  let multiplier = 1;
  switch (timeRange) {
    case '7d':
      multiplier = 10; // ~70 errors per week
      break;
    case '30d':
      multiplier = 40; // ~300 errors per month
      break;
    case '1y':
      multiplier = 450; // ~3500 errors per year
      break;
    default:
      multiplier = 10;
  }
  // Base error codes with percentages
  const baseErrorCodes = [{
    code: '05',
    description: 'Do Not Honor',
    percentage: 38.2,
    color: '#ef4444'
  }, {
    code: '51',
    description: 'Insufficient Funds',
    percentage: 29.5,
    color: '#f97316'
  }, {
    code: '14',
    description: 'Invalid Card Number',
    percentage: 12.8,
    color: '#eab308'
  }, {
    code: '54',
    description: 'Expired Card',
    percentage: 8.4,
    color: '#84cc16'
  }, {
    code: '19',
    description: 'Re-enter Transaction',
    percentage: 4.6,
    color: '#3b82f6'
  }, {
    code: 'Other',
    description: 'All Other Errors',
    percentage: 6.5,
    color: '#a3a3a3'
  }];
  // Calculate counts based on percentages and multiplier
  return baseErrorCodes.map(error => ({
    ...error,
    count: Math.round(error.percentage * multiplier)
  }));
};
interface CardErrorCodesProps {
  timeRange?: string;
}
export function CardErrorCodes({
  timeRange = '7d'
}: CardErrorCodesProps) {
  // Generate error codes with counts based on time range
  const errorCodes = generateErrorCounts(timeRange);
  // Calculate total count for reference
  const totalCount = errorCodes.reduce((sum, error) => sum + error.count, 0);
  return <div className="mt-4" data-id="element-603">
      <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-604">
        Common Decline Reasons
      </h4>
      <div className="overflow-x-auto border border-gray-200 rounded-md" data-id="element-605">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-606">
          <thead className="bg-gray-50" data-id="element-607">
            <tr data-id="element-608">
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-609">
                Code
              </th>
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-610">
                Description
              </th>
              <th scope="col" className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-611">
                Count
              </th>
              <th scope="col" className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-612">
                %
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-613">
            {errorCodes.map(error => <tr key={error.code} className="h-10" data-id="element-614">
                <td className="px-4 py-2 whitespace-nowrap text-xs text-gray-700" data-id="element-615">
                  {error.code}
                </td>
                <td className="px-4 py-2 whitespace-nowrap text-xs text-gray-700" data-id="element-616">
                  {error.description}
                </td>
                <td className="px-4 py-2 whitespace-nowrap text-xs text-right font-medium text-gray-700" data-id="element-617">
                  {error.count.toLocaleString()}
                </td>
                <td className="px-4 py-2 whitespace-nowrap text-xs text-right font-medium" style={{
              color: error.color
            }} data-id="element-618">
                  {error.percentage.toFixed(1)}%
                </td>
              </tr>)}
            <tr className="bg-gray-50 h-10" data-id="element-619">
              <td className="px-4 py-2 whitespace-nowrap text-xs font-medium text-gray-700" data-id="element-620">
                Total
              </td>
              <td className="px-4 py-2 whitespace-nowrap" data-id="element-621"></td>
              <td className="px-4 py-2 whitespace-nowrap text-xs text-right font-medium text-gray-700" data-id="element-622">
                {totalCount.toLocaleString()}
              </td>
              <td className="px-4 py-2 whitespace-nowrap text-xs text-right font-medium text-gray-700" data-id="element-623">
                100%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}